var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['status-tag', _vm.itemData.status],style:(_vm.itemData.style)},[_vm._v(" "+_vm._s(_vm.itemData.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }